const TermsOfUse = () => {
  return (
    <div className='text-gray-800 font-sans leading-relaxed'>
      <h1 className='text-3xl font-bold mb-6'>이용약관</h1>

      <h2 className='text-xl font-semibold text-gray-700 border-b-2 border-amber-500 pb-2 mb-4'>제1조 [목적]</h2>
      <p className='mb-6'>
        이 약관은 큐비(이하 "회사"라 한다)가 제공하는 AI 상담사 서비스 '큐비'를 이용함에 있어 회사와 이용자 사이의
        권리·의무 및 책임사항을 규정함을 목적으로 합니다.
      </p>

      <h2 className='text-xl font-semibold text-gray-700 border-b-2 border-amber-500 pb-2 mb-4'>제2조 [정의]</h2>
      <ol className='list-decimal pl-6 mb-6'>
        <li className='mb-3'>
          "애플리케이션"이란 회사가 제공하는 AI 상담사 서비스를 이용자에게 제공하기 위하여 컴퓨터나 모바일 기기 등
          정보통신설비를 이용하여 서비스를 제공할 수 있도록 설정한 가상의 서비스 공간을 말하며, 아울러 애플리케이션을
          운영하는 사업자의 의미로도 사용합니다.
        </li>
        <li className='mb-3'>
          "이용자"란 "애플리케이션"에 접속하여 이 약관에 따라 "회사"가 제공하는 "서비스"를 받는 회원을 말합니다.
        </li>
        <li className='mb-3'>
          "회원"이라 함은 "애플리케이션"에 SNS 로그인을 통해 회원등록을 한 자로서, 계속적으로 "애플리케이션"이 제공하는
          서비스를 이용할 수 있는 자를 말합니다.
        </li>
        <li className='mb-3'>
          "AI 상담 서비스"란 인공지능 기술을 활용하여 학생의 심리상담 및 학습상담을 제공하는 서비스를 말합니다.
        </li>
        <li className='mb-3'>
          "상담 내용"이란 회원이 AI 상담 서비스를 이용하면서 생성되는 모든 대화 내용 및 관련 데이터를 말합니다.
        </li>
      </ol>

      <h2 className='text-xl font-semibold text-gray-700 border-b-2 border-amber-500 pb-2 mb-4'>
        제3조 [약관 등의 명시와 설명 및 개정]
      </h2>
      <ol className='list-decimal pl-6 mb-6'>
        <li className='mb-3'>
          "애플리케이션"은 이 약관의 내용과 상호 및 대표자 성명, 영업소 소재지 주소, 전화번호, 전자우편주소,
          사업자등록번호, 개인정보관리책임자 등을 이용자가 쉽게 알 수 있도록 "애플리케이션"의 초기 서비스화면에
          게시합니다.
        </li>
        <li className='mb-3'>
          "애플리케이션"은 이용자가 약관을 동의하기에 앞서 약관에 정하여져 있는 내용 중 환불 조건과 같은 중요한 내용을
          이용자가 이해할 수 있도록 별도의 연결 화면 또는 팝업 화면 등을 제공하여 이용자의 확인을 구하여야 합니다.
        </li>
        <li className='mb-3'>"애플리케이션"은 관련 법령을 위배하지 않는 범위에서 이 약관을 개정할 수 있습니다.</li>
        <li className='mb-3'>
          "애플리케이션"이 이 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행 약관과 함께 애플리케이션의
          초기화면에 그 적용일자 7일 이전부터 적용일자 전일까지 공지합니다. 다만, 이용자에게 불리하게 약관 내용을
          변경하는 경우에는 최소한 30일 이상의 사전 유예기간을 두고 공지합니다.
        </li>
      </ol>

      <h2 className='text-xl font-semibold text-gray-700 border-b-2 border-amber-500 pb-2 mb-4'>
        제4조 [서비스의 제공 및 변경]
      </h2>
      <ol className='list-decimal pl-6 mb-6'>
        <li className='mb-3'>
          "애플리케이션"은 다음과 같은 서비스를 제공합니다.
          <ol className='list-decimal pl-6 mt-2'>
            <li className='mb-1'>AI를 활용한 학생 심리상담 서비스</li>
            <li className='mb-1'>AI를 활용한 학습상담 및 학습 관리 서비스</li>
            <li className='mb-1'>상담 내용 저장 및 이력 관리 서비스</li>
            <li className='mb-1'>기타 "애플리케이션"이 정하는 서비스</li>
          </ol>
        </li>
        <li className='mb-3'>
          "애플리케이션"은 기술적 사양의 변경 등의 경우에는 장차 체결되는 계약에 의해 제공할 서비스의 내용을 변경할 수
          있습니다. 이 경우에는 변경된 서비스의 내용 및 제공일자를 명시하여 현재의 서비스 내용을 게시한 곳에 즉시
          공지합니다.
        </li>
      </ol>

      <h2 className='text-xl font-semibold text-gray-700 border-b-2 border-amber-500 pb-2 mb-4'>
        제5조 [서비스의 중단]
      </h2>
      <ol className='list-decimal pl-6 mb-6'>
        <li className='mb-3'>
          "애플리케이션"은 컴퓨터 등 정보통신설비의 보수점검·교체 및 고장, 통신의 두절 등의 사유가 발생한 경우에는
          서비스의 제공을 일시적으로 중단할 수 있습니다.
        </li>
        <li className='mb-3'>
          사업종목의 전환, 사업의 포기, 업체 간의 통합 등의 이유로 서비스를 제공할 수 없게 되는 경우에는
          "애플리케이션"은 제8조에 정한 방법으로 이용자에게 통지합니다.
        </li>
      </ol>

      <h2 className='text-xl font-semibold text-gray-700 border-b-2 border-amber-500 pb-2 mb-4'>제6조 [회원가입]</h2>
      <ol className='list-decimal pl-6 mb-6'>
        <li className='mb-3'>
          이용자는 "애플리케이션"이 지원하는 SNS 로그인(카카오, 구글, 애플 로그인)을 통해 가입 절차를 진행하고 이 약관에
          동의한다는 의사표시를 함으로써 회원가입을 신청합니다.
        </li>
        <li className='mb-3'>
          SNS 로그인을 통해 제공받는 정보는 다음과 같습니다.
          <ol className='list-decimal pl-6 mt-2'>
            <li className='mb-1'>이름 또는 닉네임</li>
            <li className='mb-1'>이메일 주소</li>
            <li className='mb-1'>프로필 사진 (선택사항)</li>
            <li className='mb-1'>기타 해당 SNS에서 제공하는 기본 정보</li>
          </ol>
        </li>
        <li className='mb-3'>
          "애플리케이션"은 제1항과 같이 회원으로 가입할 것을 신청한 이용자 중 다음 각 호에 해당하지 않는 한 회원으로
          등록합니다.
          <ol className='list-decimal pl-6 mt-2'>
            <li className='mb-1'>만 14세 미만인 경우 (법정대리인 동의 없는 경우)</li>
            <li className='mb-1'>
              이전에 회원자격을 상실한 적이 있는 경우 (다만, 회원자격 상실 후 3년이 경과한 자로서 회사의 재가입 승낙을
              얻은 경우 제외)
            </li>
            <li className='mb-1'>등록 내용에 허위, 기재누락, 오기가 있는 경우</li>
            <li className='mb-1'>
              기타 회원으로 등록하는 것이 "애플리케이션"의 기술상 현저히 지장이 있다고 판단되는 경우
            </li>
          </ol>
        </li>
      </ol>

      <h2 className='text-xl font-semibold text-gray-700 border-b-2 border-amber-500 pb-2 mb-4'>
        제7조 [회원 탈퇴 및 자격 상실 등]
      </h2>
      <ol className='list-decimal pl-6 mb-6'>
        <li className='mb-3'>
          회원은 "애플리케이션"에 언제든지 탈퇴를 요청할 수 있으며 "애플리케이션"은 즉시 회원탈퇴를 처리합니다.
        </li>
        <li className='mb-3'>
          회원이 다음 각 호의 사유에 해당하는 경우, "애플리케이션"은 회원자격을 제한 및 정지시킬 수 있습니다.
          <ol className='list-decimal pl-6 mt-2'>
            <li className='mb-1'>가입 신청 시에 허위 내용을 등록한 경우</li>
            <li className='mb-1'>다른 사람의 서비스 이용을 방해하거나 그 정보를 도용하는 경우</li>
            <li className='mb-1'>
              서비스를 이용하여 법령 또는 이 약관이 금지하거나 공서양속에 반하는 행위를 하는 경우
            </li>
            <li className='mb-1'>AI 상담사에게 부적절한 내용을 전달하거나 서비스를 악용하는 경우</li>
          </ol>
        </li>
      </ol>

      <h2 className='text-xl font-semibold text-gray-700 border-b-2 border-amber-500 pb-2 mb-4'>
        제8조 [회원에 대한 통지]
      </h2>
      <ol className='list-decimal pl-6 mb-6'>
        <li className='mb-3'>
          "애플리케이션"이 회원에 대한 통지를 하는 경우, 회원이 SNS 로그인을 통해 제공한 이메일 주소 및 애플리케이션 내
          푸시 알림으로 할 수 있습니다.
        </li>
        <li className='mb-3'>
          "애플리케이션"은 불특정다수 회원에 대한 통지의 경우 1주일 이상 "애플리케이션" 게시판에 게시함으로써 개별
          통지에 갈음할 수 있습니다.
        </li>
      </ol>

      <h2 className='text-xl font-semibold text-gray-700 border-b-2 border-amber-500 pb-2 mb-4'>
        제9조 [유료서비스 이용 및 결제]
      </h2>
      <ol className='list-decimal pl-6 mb-6'>
        <li className='mb-3'>
          "애플리케이션"의 기본 서비스는 무료로 제공되며, 추가 기능 이용을 위한 유료 구독 서비스를 제공할 수 있습니다.
        </li>
        <li className='mb-3'>유료 구독 서비스는 월 단위 정기결제 방식으로 제공됩니다.</li>
        <li className='mb-3'>
          결제 수단은 다음과 같습니다.
          <ol className='list-decimal pl-6 mt-2'>
            <li className='mb-1'>신용카드, 직불카드 등 각종 카드 결제</li>
            <li className='mb-1'>애플리케이션 스토어 내 결제 시스템</li>
            <li className='mb-1'>기타 회사가 지정하는 결제 수단</li>
          </ol>
        </li>
      </ol>

      <h2 className='text-xl font-semibold text-gray-700 border-b-2 border-amber-500 pb-2 mb-4'>
        제10조 [상담 내용의 저장 및 관리]
      </h2>
      <ol className='list-decimal pl-6 mb-6'>
        <li className='mb-3'>"애플리케이션"은 회원의 상담 내용을 서비스 제공 목적으로 저장합니다.</li>
        <li className='mb-3'>
          상담 내용의 보관 기간은 회원 탈퇴 후 1년까지로 하며, 해당 기간 경과 후 자동으로 삭제됩니다.
        </li>
        <li className='mb-3'>회원은 언제든지 자신의 상담 내용을 열람하고 삭제를 요구할 수 있습니다.</li>
      </ol>

      <h2 className='text-xl font-semibold text-gray-700 border-b-2 border-amber-500 pb-2 mb-4'>
        제11조 [AI 상담의 한계 및 긴급상황 대응]
      </h2>
      <ol className='list-decimal pl-6 mb-6'>
        <li className='mb-3'>
          AI 상담 서비스는 전문 상담사의 상담을 완전히 대체할 수 없으며, 심각한 정신건강 문제의 경우 전문 의료진 상담을
          권장합니다.
        </li>
        <li className='mb-3'>
          회원이 자해, 자살 등 긴급한 위험 상황을 나타내는 내용을 전달할 경우, 회사는 다음과 같이 대응할 수 있습니다.
          <ol className='list-decimal pl-6 mt-2'>
            <li className='mb-1'>즉시 전문 상담 기관 연락처 안내</li>
            <li className='mb-1'>관련 법령에 따른 관계 기관 신고</li>
            <li className='mb-1'>회원의 안전을 위한 필요한 조치</li>
          </ol>
        </li>
        <li className='mb-3'>
          상담 내용의 비밀은 보장되나, 회원의 생명과 안전에 급박한 위험이 있다고 판단되는 경우 관련 기관에 신고할 수
          있습니다.
        </li>
      </ol>

      <h2 className='text-xl font-semibold text-gray-700 border-b-2 border-amber-500 pb-2 mb-4'>제12조 [환불 정책]</h2>
      <ol className='list-decimal pl-6 mb-6'>
        <li className='mb-3'>
          월 구독 서비스의 환불은 다음과 같이 처리됩니다.
          <ol className='list-decimal pl-6 mt-2'>
            <li className='mb-1'>결제 후 7일 이내이고 서비스를 이용하지 않은 경우: 전액 환불</li>
            <li className='mb-1'>결제 후 7일이 경과했거나 서비스를 이용한 경우: 환불 불가</li>
            <li className='mb-1'>서비스 장애로 인한 이용 불가 시: 해당 기간 비례 환불</li>
          </ol>
        </li>
        <li className='mb-3'>환불 요청은 고객센터를 통해 신청할 수 있으며, 승인된 환불은 3영업일 이내에 처리됩니다.</li>
      </ol>

      <h2 className='text-xl font-semibold text-gray-700 border-b-2 border-amber-500 pb-2 mb-4'>
        제13조 [개인정보보호]
      </h2>
      <ol className='list-decimal pl-6 mb-6'>
        <li className='mb-3'>
          "애플리케이션"은 이용자의 개인정보 수집 시 서비스 제공을 위하여 필요한 범위에서 최소한의 개인정보를
          수집합니다.
        </li>
        <li className='mb-3'>
          수집된 개인정보는 목적 외의 용도로 이용되지 않으며, 회원의 동의 없이 제3자에게 제공되지 않습니다.
        </li>
        <li className='mb-3'>
          상담 내용은 개인정보로서 엄격히 보호되며, 법령에서 정한 경우를 제외하고는 외부에 공개되지 않습니다.
        </li>
      </ol>

      <h2 className='text-xl font-semibold text-gray-700 border-b-2 border-amber-500 pb-2 mb-4'>
        제14조 [회사의 의무]
      </h2>
      <ol className='list-decimal pl-6 mb-6'>
        <li className='mb-3'>
          "애플리케이션"은 법령과 이 약관이 금지하거나 공서양속에 반하는 행위를 하지 않으며, 안정적이고 지속적인 서비스
          제공을 위해 최선을 다합니다.
        </li>
        <li className='mb-3'>
          "애플리케이션"은 이용자가 안전하게 서비스를 이용할 수 있도록 개인정보 보호를 위한 보안 시스템을 갖추어야
          합니다.
        </li>
        <li className='mb-3'>
          "애플리케이션"은 서비스 제공과 관련하여 알게 된 회원의 정보를 본인의 승낙 없이 제3자에게 누설하지 않습니다.
        </li>
      </ol>

      <h2 className='text-xl font-semibold text-gray-700 border-b-2 border-amber-500 pb-2 mb-4'>
        제15조 [회원의 의무]
      </h2>
      <ol className='list-decimal pl-6 mb-6'>
        <li className='mb-3'>
          회원은 다음 각 호에 해당하는 행위를 하여서는 안 됩니다.
          <ol className='list-decimal pl-6 mt-2'>
            <li className='mb-1'>허위 내용의 등록</li>
            <li className='mb-1'>타인의 정보 도용</li>
            <li className='mb-1'>외설 또는 폭력적인 내용의 전송</li>
            <li className='mb-1'>다른 회원에게 수치심을 주거나 괴롭히는 행위</li>
            <li className='mb-1'>AI 상담 서비스의 정상적인 운영을 방해하는 행위</li>
            <li className='mb-1'>관련 법령에 위배되는 행위</li>
          </ol>
        </li>
        <li className='mb-3'>
          회원은 관계 법령, 본 약관의 규정, 이용안내 및 서비스상에 공지한 주의사항을 준수해야 합니다.
        </li>
      </ol>

      <h2 className='text-xl font-semibold text-gray-700 border-b-2 border-amber-500 pb-2 mb-4'>제16조 [면책조항]</h2>
      <ol className='list-decimal pl-6 mb-6'>
        <li className='mb-3'>
          회사는 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우 서비스 제공에 관한 책임이
          면제됩니다.
        </li>
        <li className='mb-3'>
          회사는 회원의 귀책사유로 인해 발생한 서비스 이용의 장애에 대하여는 책임을 지지 않습니다.
        </li>
        <li className='mb-3'>
          회사는 AI 상담 서비스의 내용이나 결과에 대해 의료적 책임을 지지 않으며, 전문적인 치료가 필요한 경우 전문
          의료진 상담을 권장합니다.
        </li>
        <li className='mb-3'>
          회사는 회원이 상담 내용과 관련하여 게재한 정보, 자료의 신뢰도, 정확성 등에 관하여는 책임을 지지 않습니다.
        </li>
      </ol>

      <h2 className='text-xl font-semibold text-gray-700 border-b-2 border-amber-500 pb-2 mb-4'>
        제17조 [저작권의 귀속]
      </h2>
      <ol className='list-decimal pl-6 mb-6'>
        <li className='mb-3'>
          "애플리케이션"이 작성한 저작물에 대한 저작권 기타 지적재산권은 "애플리케이션"에 귀속합니다.
        </li>
        <li className='mb-3'>
          이용자는 "애플리케이션"을 이용함으로써 얻은 정보를 "애플리케이션"의 사전 승낙 없이 복제, 송신, 출판, 배포,
          방송 기타 방법에 의하여 영리목적으로 이용하거나 제3자에게 이용하게 하여서는 안됩니다.
        </li>
      </ol>

      <h2 className='text-xl font-semibold text-gray-700 border-b-2 border-amber-500 pb-2 mb-4'>
        제18조 [분쟁해결 및 재판관할]
      </h2>
      <ol className='list-decimal pl-6 mb-6'>
        <li className='mb-3'>
          "애플리케이션"은 이용자가 제기하는 정당한 의견이나 불만을 반영하고 그 피해를 보상처리하기 위하여
          피해보상처리기구를 설치·운영합니다.
        </li>
        <li className='mb-3'>
          "애플리케이션"과 이용자 간에 발생한 분쟁에 관한 소송은 민사소송법상의 관할법원에 제기합니다.
        </li>
      </ol>

      <h2 className='text-xl font-semibold text-gray-700 border-b-2 border-amber-500 pb-2 mb-4'>부칙</h2>
      <p className='text-center mt-10 font-bold'>이 약관은 2025년 6월 28일부터 시행합니다.</p>
    </div>
  )
}

export default TermsOfUse
